// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HttpError_wrapper__2hLDR","code":"HttpError_code__3v0d0","title":"HttpError_title__3BPnj","link":"HttpError_link__1LC-k"};